// extracted by css-extract-rspack-plugin
module.exports =  {"root":"d964de88b3","compact":"adcc437379","pictureWrapper":"bea164ce5f","picture":"ff16d09792","rating":"df07f2ecfd","name":"a90f941597"};